import { render } from "./SettingsComp.vue?vue&type=template&id=4a6e1e75"
import script from "../settings.js?vue&type=script&lang=js&external"
export * from "../settings.js?vue&type=script&lang=js&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__